const normalized = (value) => String(value || '').trim().toLocaleLowerCase();

const sharesSource = (left, right) => {
  const rightSources = new Set(Array.isArray(right?.source_ids) ? right.source_ids : []);
  return (Array.isArray(left?.source_ids) ? left.source_ids : []).some((id) => rightSources.has(id));
};

const sameNode = (left, right) => Boolean(
  left && right && (
    (left.id && right.id && left.id === right.id)
    || (normalized(left.label) && normalized(left.label) === normalized(right.label))
    || sharesSource(left, right)
  )
);

const reconcileNode = (previous, next) => {
  if (!previous) return next;
  const previousChildren = Array.isArray(previous.children) ? previous.children : [];
  const nextChildren = Array.isArray(next?.children) ? next.children : [];
  const used = new Set();

  // Preserve the visible order of surviving bubbles, then append new ideas.
  const children = [];
  previousChildren.forEach((oldChild) => {
    const nextIndex = nextChildren.findIndex(
      (candidate, index) => !used.has(index) && sameNode(oldChild, candidate),
    );
    if (nextIndex < 0) return;
    used.add(nextIndex);
    children.push(reconcileNode(oldChild, nextChildren[nextIndex]));
  });
  nextChildren.forEach((newChild, index) => {
    if (!used.has(index)) children.push(newChild);
  });

  return {
    ...next,
    // A stable key prevents an existing bubble from being remounted or jumping.
    id: previous.id || next.id,
    children,
  };
};

export default function reconcileMindMap(previous, next) {
  if (!previous?.root) return next;
  if (!next?.root) return previous;
  return {
    ...next,
    root: reconcileNode(previous.root, next.root),
  };
}
